import { useState, useEffect } from 'react';

const LOGO = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_php-sample-build/artifacts/ftajnjjx_New%20Noax%20Logo%20-%2003.png';
const DURATION = 2400; // total splash visible time (ms)

export const SplashPreloader = () => {
  const [state, setState] = useState('showing'); // showing | fading | done

  useEffect(() => {
    // Only run once per browser tab
    if (sessionStorage.getItem('noax_splash_seen')) {
      setState('done');
      return;
    }
    // Freeze page scroll while splash is up
    document.body.style.overflow = 'hidden';

    const fadeTimer = setTimeout(() => setState('fading'), DURATION);
    const doneTimer = setTimeout(() => {
      setState('done');
      sessionStorage.setItem('noax_splash_seen', '1');
      document.body.style.overflow = '';
    }, DURATION + 700);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
      document.body.style.overflow = '';
    };
  }, []);

  if (state === 'done') return null;

  return (
    <div
      className={`splash-preloader ${state === 'fading' ? 'is-fading' : ''}`}
      data-testid="splash-preloader"
      aria-hidden="true"
    >
      {/* Ambient glow blobs */}
      <div className="splash-blob splash-blob-1" />
      <div className="splash-blob splash-blob-2" />
      <div className="splash-grid" />

      {/* Logo with unique reveal + shimmer */}
      <div className="splash-logo-wrap">
        <div className="splash-glow" />
        <img
          src={LOGO}
          alt="Noax Media"
          className="splash-logo"
          data-testid="splash-logo"
        />
      </div>

      {/* Loader */}
      <div className="splash-progress" data-testid="splash-progress">
        <div className="splash-progress-fill" />
      </div>
      <div className="splash-caption">Real-Time Leads. Real Growth.</div>
    </div>
  );
};
